import { AdView } from "./views/AdView";
import { injectable, inject } from "@launchtray/tsyringe-async";
import { Viewable, PromiseCompletionSource } from "scene-manager";
import { InjectableInterfaces } from "../../../composition/InjectableInterfaces";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";

@injectable()
export class AdScene extends Viewable<boolean> {
    public constructor(@inject(InjectableInterfaces.ICanvasScaler) private readonly canvasScaler: ICanvasScaler) {
        super();
        const pcs = new PromiseCompletionSource<boolean>();
        this.view = new AdView(this.canvasScaler, pcs);
        pcs.result.then(
            () => {
                this.operationControls.complete(true);
            },
            (reason: unknown) => {
                console.warn("AdPopupScene rejected with reason:", reason);
                this.operationControls.error(false);
            }
        );
    }
}
